<template>
	<TeamingDropDown
		class="team-dropdown"
		:disabled="disabled"
		:options="options"
		:value="value"
	>
		<template #selector-icon="{ selectedOption, onSelectorClicked }">
			<div v-if="selectedOption.mark">
				<TeamingChip class="option-mark" @click="onSelectorClicked">
					<template #text>{{ selectedOption.mark }}</template>
				</TeamingChip>
			</div>
		</template>
		<template #options="{ option, selectedOption, onOptionClicked }">
			<DropDownRow
				:option="option"
				:is-selected="option.value === selectedOption.value"
				@click="onOptionClicked( option, $event )"
			/>
		</template>
	</TeamingDropDown>
</template>

<script>
import TeamingDropDown from "./TeamingDropDown";
import DropDownRow from "./DropDownRow.vue";
import TeamingChip from "./TeamingChip";

export default {
	name: "TeamDropDown",
	components: {
		DropDownRow,
		TeamingDropDown,
		TeamingChip,
	},
	props: {
		disabled: {
			type: Boolean,
			default: false,
		},
		/** [ { text:String, value:String, mark:String, count:Number|String } ] */
		options: {
			type: Array,
			required: true,
		},
		value: {
			type: String,
			required: true,
		},
	},
};
</script>

<style lang="scss" scoped>
$team-dropdown-option-mark-color: $white;
$team-dropdown-option-mark-background-color: $color1-500;

.team-dropdown .option-mark {
	color: $team-dropdown-option-mark-color;
	background-color: $team-dropdown-option-mark-background-color;
	border-radius: 0.6rem;
}
</style>

<style lang="scss">
.team-dropdown {
	.teaming-drop-down__options {
		max-height: 15rem;
		@include auto-y-scroll();
	}

	// override defaults
	.teaming-drop-down__option {
		margin: 0;
		padding: 0.25rem 0.5rem;

		&:first-of-type {
			margin-top: 0.25rem;
		}

		&:last-of-type {
			margin-bottom: 0.25rem;
		}
	}
}
</style>
